import type { GiftTerm } from '@shared/types';

export const config = {
  paddle: {
    environment: (import.meta.env.VITE_PADDLE_ENVIRONMENT || 'sandbox') as 'sandbox' | 'production',
    clientToken: import.meta.env.VITE_PADDLE_CLIENT_TOKEN || '',
    priceIds: {
      '3m': import.meta.env.VITE_PADDLE_PRICE_ID_GIFT_3M || '',
      '6m': import.meta.env.VITE_PADDLE_PRICE_ID_GIFT_6M || '',
    } as Record<GiftTerm, string>,
  },
  appUrl: import.meta.env.VITE_APP_URL || 'https://app.betteroo.ai',
  siteUrl: import.meta.env.VITE_SITE_URL || 'https://betteroo.ai',
  supportEmail: 'support@betteroo.ai',
} as const;
